import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 2a1 1 0 0 1 0 2v14a4 4 0 1 1 -8 0v-14a1 1 0 1 1 0 -2zm-2 2h-4v7h4z","key":"svg-0"}]]

/**
 * IconTestPipe2Filled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItdGVzdC1waXBlLTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE2IDJhMSAxIDAgMCAxIDAgMnYxNGE0IDQgMCAxIDEgLTggMHYtMTRhMSAxIDAgMSAxIDAgLTJ6bS0yIDJoLTR2N2g0eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/test-pipe-2-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTestPipe2Filled = createReactComponent('filled', 'test-pipe-2-filled', 'TestPipe2Filled', __iconNode);

export default IconTestPipe2Filled;